/* The Toy Gift Shop — theme.js (ES2017, no optional chaining, no third-party code)
   Modules: money, Reveal, Header, MegaMenu, Drawers, MobileMenu, PredictiveSearch,
   AnnouncementBar, Delivery (shared date maths), TgsCart (single-flight cart with gift pairing),
   CartUI (drawer + page share one renderer). */
(function () {
  'use strict';
  var TGS = window.TGS || {};
  var S = TGS.strings || {};
  var d = document;

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function money(cents) {
    var format = TGS.moneyFormat || 'Rs. {{amount}}';
    var value = Number(cents) / 100;
    if (!Number.isFinite(value)) value = 0;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      var comma = token.indexOf('comma_separator') !== -1;
      var space = token.indexOf('space_separator') !== -1;
      var apostrophe = token.indexOf('apostrophe_separator') !== -1;
      var noDecimals = token.indexOf('no_decimals') !== -1;
      var digits = noDecimals ? 0 : 2;
      var parts = value.toFixed(digits).split('.');
      var group = comma ? '.' : space ? ' ' : apostrophe ? "'" : ',';
      var decimal = comma ? ',' : '.';
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
      return whole + (parts[1] && parts[1] !== '00' ? decimal + parts[1] : '');
    }).replace(/<[^>]+>/g, '');
  }

  function fmt(str, map) { var s = str || ''; Object.keys(map || {}).forEach(function (k) { s = s.split('[' + k + ']').join(map[k]); }); return s; }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function trapFocus(panel) {
    return function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return el.getClientRects().length && !el.closest('[hidden],[inert]'); });
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    };
  }
  function toast(msg) {
    var t = $('#Toast');
    if (!t) { t = d.createElement('div'); t.id = 'Toast'; t.className = 'toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }
  window.TGS = TGS; TGS.money = money; TGS.toast = toast; TGS.fmt = fmt;

  /* ---------- Reveal (IO feature-detected; CSS is .js-gated) ---------- */
  (function Reveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('revealed'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('revealed'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0.01 });
    els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 1.5) el.classList.add('revealed'); else io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('revealed'); }); }, 2500);
    d.addEventListener('shopify:section:load', function (e) { $$('[data-reveal]', e.target).forEach(function (el) { io.observe(el); }); });
  })();

  /* ---------- English / Roman Urdu switch (FAQ sections, policy pages) ---------- */
  (function LangToggle() {
    // policy pages: Shopify renders the policy body; if it carries both versions, add the switch above it
    var pol = $('.shopify-policy__container');
    if (pol && $('.lang-ur', pol) && !$('[data-lang-root]', pol)) {
      pol.setAttribute('data-lang-root', '');
      var t = d.createElement('div');
      t.innerHTML = '<div class="langbar"><span class="langbar__label" id="LangLabel-policy">Read in</span><div class="langswitch" role="group" aria-labelledby="LangLabel-policy"><span class="langswitch__thumb" aria-hidden="true"></span><button type="button" class="langswitch__btn" data-lang-set="en" aria-pressed="true">English</button><button type="button" class="langswitch__btn" data-lang-set="ur" aria-pressed="false" lang="ur-Latn">Roman Urdu</button></div></div>';
      var title = $('.shopify-policy__title', pol); (title || pol.firstChild).insertAdjacentElement('afterend', t.firstChild);
    }
    var roots = $$('[data-lang-root]'); if (!roots.length) return;
    var saved = null; try { saved = localStorage.getItem('tgs-lang'); } catch (e) {}
    function apply(lang) {
      roots.forEach(function (r) {
        r.setAttribute('data-lang', lang);
        $$('[data-lang-set]', r).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lang-set') === lang ? 'true' : 'false'); });
      });
    }
    apply(saved === 'ur' ? 'ur' : 'en');
    on(d, 'click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lang-set]'); if (!b) return;
      var lang = b.getAttribute('data-lang-set'); apply(lang);
      try { localStorage.setItem('tgs-lang', lang); } catch (err) {}
    });
  })();

  /* ---------- Header: scrolled state ---------- */
  (function Header() {
    var h = $('[data-header]'); if (!h) return;
    var ticking = false;
    function upd() { h.classList.toggle('is-scrolled', window.scrollY > 120); ticking = false; }
    on(window, 'scroll', function () { if (!ticking) { requestAnimationFrame(upd); ticking = true; } }, { passive: true });
    upd();
  })();

  /* ---------- Mega menu: hover intent + keyboard + outside click ---------- */
  (function MegaMenu() {
    var items = $$('[data-mega]'); if (!items.length) return;
    var openItem = null, timer;
    function open(it) { if (openItem && openItem !== it) close(openItem); it.classList.add('is-open'); it.querySelector('.nav__link').setAttribute('aria-expanded', 'true'); openItem = it; }
    function close(it) { it.classList.remove('is-open'); it.querySelector('.nav__link').setAttribute('aria-expanded', 'false'); if (openItem === it) openItem = null; }
    items.forEach(function (it) {
      var link = it.querySelector('.nav__link');
      link.setAttribute('aria-haspopup', 'true'); link.setAttribute('aria-expanded', 'false');
      on(it, 'mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { open(it); }, 80); });
      on(it, 'mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { close(it); }, 160); });
      on(link, 'click', function (e) { if (it.classList.contains('is-open')) { close(it); } else { e.preventDefault(); open(it); } });
      on(it, 'keydown', function (e) { if (e.key === 'Escape') { close(it); link.focus(); } });
      on(it, 'focusout', function (e) { if (!it.contains(e.relatedTarget)) close(it); });
    });
    on(d, 'click', function (e) { if (openItem && !openItem.contains(e.target)) close(openItem); });
  })();

  /* ---------- Drawers ---------- */
  var Drawers = (function () {
    var open = null, lastFocus = null, trap = null;
    function get(name) { return $('[data-drawer="' + name + '"]'); }
    function show(name) {
      var dr = get(name); if (!dr) return;
      if (open && open !== dr) hide();
      lastFocus = d.activeElement;
      dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false'); d.body.classList.add('drawer-open');
      open = dr;
      var panel = $('.drawer__panel', dr);
      trap = trapFocus(panel); if (trap) on(dr, 'keydown', trap);
      var focusEl = $('[data-autofocus]', dr) || $('[data-drawer-close]', dr);
      setTimeout(function () { if (focusEl) focusEl.focus(); }, 60);
      dr.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
      $$('[aria-controls="' + dr.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function hide() {
      if (!open) return;
      var dr = open;
      dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); d.body.classList.remove('drawer-open');
      if (trap) dr.removeEventListener('keydown', trap);
      $$('[aria-controls="' + dr.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      open = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    $$('[data-drawer]').forEach(function (dr) {
      dr.setAttribute('aria-hidden', 'true');
      if (dr.getAttribute('data-drawer') === 'filters') {
        var desktop = window.matchMedia('(min-width: 990px)');
        function syncFilters() {
          if (desktop.matches) {
            if (open === dr) hide();
            dr.removeAttribute('aria-hidden'); dr.removeAttribute('aria-modal'); dr.removeAttribute('role');
          } else {
            dr.setAttribute('aria-hidden', dr.classList.contains('is-open') ? 'false' : 'true');
            dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-modal', 'true');
          }
        }
        if (desktop.addEventListener) desktop.addEventListener('change', syncFilters);
        syncFilters();
      }
      $$('[data-drawer-close]', dr).forEach(function (b) { on(b, 'click', hide); });
      var bd = $('.drawer__backdrop', dr); on(bd, 'click', hide);
    });
    on(d, 'keydown', function (e) { if (e.key === 'Escape' && open) hide(); });
    $$('[data-drawer-open]').forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); show(b.getAttribute('data-drawer-open')); });
    });
    return { show: show, hide: hide, current: function () { return open; } };
  })();
  TGS.drawers = Drawers;

  /* ---------- Announcements: stable text, explicit previous/next controls ---------- */
  (function Announcements() {
    function init(scope) {
      $$('[data-announcement]', scope).forEach(function (bar) {
        if (bar.dataset.ready) return; bar.dataset.ready = 'true';
        var messages = $$('.announcement__msg', bar), index = 0;
        function show(next) { index = (next + messages.length) % messages.length; messages.forEach(function (message, i) { message.setAttribute('aria-hidden', i === index ? 'false' : 'true'); message.inert = i !== index; }); }
        if (!messages.length) return;
        // auto-advance so every message gets seen; paused while hovered or focused, off under reduced motion, restarted after a manual step
        var secs = parseInt(bar.getAttribute('data-rotate') || '0', 10), timer = null, paused = false;
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function stop() { clearInterval(timer); timer = null; }
        function start() { stop(); if (secs > 0 && messages.length > 1 && !still && !paused) timer = setInterval(function () { show(index + 1); }, secs * 1000); }
        on($('[data-announcement-prev]', bar), 'click', function () { show(index - 1); start(); });
        on($('[data-announcement-next]', bar), 'click', function () { show(index + 1); start(); });
        on(bar, 'mouseenter', function () { paused = true; stop(); }); on(bar, 'mouseleave', function () { paused = false; start(); });
        on(bar, 'focusin', function () { paused = true; stop(); }); on(bar, 'focusout', function () { if (!bar.contains(d.activeElement)) { paused = false; start(); } });
        on(d, 'visibilitychange', function () { if (d.hidden) stop(); else start(); });
        show(0); start();
      });
    }
    init(d);on(d, 'shopify:section:load', function (e) { init(e.target); });
  })();

  /* ---------- Predictive search ---------- */
  (function PredictiveSearch() {
    $$('[data-predictive]').forEach(function (wrap) {
      var input = $('[data-predictive-input]', wrap), results = $('[data-predictive-results]', wrap);
      if (!input || !results) return;
      var ctrl = null, revision = 0;
      function clear() { while (results.firstChild) results.removeChild(results.firstChild); }
      function el(tag, cls, text) { var e = d.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function render(data) {
        clear();
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        var cols = (data.resources && data.resources.results && data.resources.results.collections) || [];
        prods = prods.filter(function (p) { return !(p.tags || []).some(function (t) { return t === 'hidden-addon'; }); });
        if (!prods.length && !cols.length) { results.appendChild(el('p', 'ps__empty', fmt(S.noResults || 'Nothing found.', {}))); return; }
        if (prods.length) {
          results.appendChild(el('p', 'ps__group-title', 'Toys'));
          prods.slice(0, 4).forEach(function (p) {
            var a = el('a', 'ps__item'); a.href = p.url;
            var img = el('img', 'ps__img'); img.alt = ''; img.loading = 'lazy'; img.width = 56; img.height = 56; if (p.featured_image && p.featured_image.url) img.src = p.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2');
            var b = el('div'); b.appendChild(el('div', 'ps__title', p.title));
            b.appendChild(el('div', 'ps__price', money(parseFloat(p.price) * 100)));
            a.appendChild(img); a.appendChild(b); results.appendChild(a);
          });
        }
        if (cols.length) {
          results.appendChild(el('p', 'ps__group-title', 'Collections'));
          cols.slice(0, 2).forEach(function (c) { var a = el('a', 'ps__item'); a.href = c.url; a.appendChild(el('div', 'ps__title', c.title)); results.appendChild(a); });
        }
        var all = el('a', 'link link--arrow', 'See all results'); all.href = (TGS.routes.search || '/search') + '?q=' + encodeURIComponent(input.value) + '&type=product'; all.style.marginTop = '12px'; all.style.display = 'inline-flex'; results.appendChild(all);
      }
      var run = debounce(function () {
        var version = revision;
        var q = input.value.trim();
        if (q.length < 2) { clear(); return; }
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = ('AbortController' in window) ? new AbortController() : null;
        var url = (TGS.routes && TGS.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('search'); return r.json(); })
          .then(function (data) { if (version === revision) render(data); }).catch(function (e) { if (version === revision && e.name !== 'AbortError') { clear(); results.appendChild(el('p', 'ps__empty', 'Suggestions are unavailable. Press Search to see results.')); } }).then(function () { if (version === revision) results.removeAttribute('aria-busy'); });
      }, 300);
      on(input, 'input', function () { revision++; if (ctrl) ctrl.abort(); clear(); results.removeAttribute('aria-busy'); if (input.value.trim().length >= 2) { results.setAttribute('aria-busy', 'true'); run(); } });
      on(input, 'keydown', function (e) { if (e.key === 'ArrowDown') { var first = $('a', results); if (first) { e.preventDefault(); first.focus(); } } });
      on(results, 'keydown', function (e) { if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return; var links = $$('a', results), i = links.indexOf(d.activeElement); if (i < 0) return; e.preventDefault(); if (e.key === 'ArrowUp' && i === 0) input.focus(); else links[Math.max(0, Math.min(links.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)))].focus(); });
    });
  })();

  /* ---------- Delivery date maths (Asia/Karachi, no DST) ---------- */
  var Delivery = (function () {
    var cfg = TGS.delivery || {};
    var WD = (cfg.workingDays || ['1','2','3','4','5','6']).map(function (x) { return parseInt(x, 10); });
    WD = WD.filter(function (day) { return day >= 0 && day <= 6; }); if (!WD.length) WD = [1,2,3,4,5,6];
    var HOL = (cfg.holidays || []).map(function (s) { return (s || '').trim(); }).filter(Boolean);
    function pkNow() { var n = new Date(); return new Date(n.getTime() + (n.getTimezoneOffset() + 300) * 60000); }
    function ymd(dt) { return dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2); }
    function isWorking(dt) { return WD.indexOf(dt.getDay()) !== -1 && HOL.indexOf(ymd(dt)) === -1; }
    function addWD(dt, n) { var x = new Date(dt.getTime()); var left = n; while (left > 0) { x.setDate(x.getDate() + 1); if (isWorking(x)) left--; } if (n === 0 && !isWorking(x)) { while (!isWorking(x)) x.setDate(x.getDate() + 1); } return x; }
    var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'], DAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    function short(dt) { return DAY[dt.getDay()] + ' ' + dt.getDate() + ' ' + MON[dt.getMonth()]; }
    function range(a, b) { return short(a) === short(b) ? short(a) : short(a) + ' – ' + short(b); }
    function num(v, dflt) { return typeof v === 'number' ? v : dflt; }
    // one window for the whole country, fastest transit (metro) to slowest (other cities): the same range the
    // no-JS fallback and the product JSON-LD state, so a shopper never sees a promise the rest of the site doesn't make
    function compute(gift) {
      var now = pkNow(), start = new Date(now.getTime());
      if (now.getHours() >= (cfg.cutoffHour || 14)) start.setDate(start.getDate() + 1);
      var dMax = gift ? Math.max(cfg.dispatchMax || 2, cfg.giftDispatchMax || 2) : (cfg.dispatchMax || 2);
      var ready0 = addWD(start, cfg.dispatchMin || 1), ready1 = addWD(start, dMax);
      var t0 = Math.min(num(cfg.metroMin, 2), num(cfg.restMin, 2)), t1 = Math.max(num(cfg.metroMax, 5), num(cfg.restMax, 5));
      var del0 = addWD(ready0, t0), del1 = addWD(ready1, t1);
      return { ordered: short(now), dispatched: range(ready0, ready1), delivered: range(del0, del1) };
    }
    return { compute: compute };
  })();
  TGS.deliveryCalc = Delivery;

  /* ---------- TgsCart: single-flight queue, gift pairing, orphan sweeps ---------- */
  var TgsCart = (function () {
    var R = TGS.routes || {}; var G = TGS.gift || {};
    var state = null, queue = Promise.resolve(), pendingUpdates = {}, flushTimer = null, cleaning = false;
    function isFee(item) { return item.handle === G.handle || item.product_type === 'Add-on'; }
    function req(url, body) {
      var opts = { method: body ? 'POST' : 'GET', headers: { 'Accept': 'application/json' } };
      if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
      return fetch(url, opts).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || S.cartError || 'Cart error'); err.data = j; throw err; } return j; });
      });
    }
    function enqueue(fn) { queue = queue.then(fn, fn); return queue; }
    function pair(cart) {
      var fees = cart.items.filter(isFee), mains = cart.items.filter(function (i) { return !isFee(i); });
      var used = {}, pairs = [];
      mains.forEach(function (m) {
        var ref = m.properties && m.properties._gift_ref, fee = null;
        if (ref) { for (var i = 0; i < fees.length; i++) { if (!used[fees[i].key] && fees[i].properties && fees[i].properties._gift_ref === ref) { fee = fees[i]; used[fee.key] = true; break; } } }
        pairs.push({ main: m, fee: fee, ref: ref });
      });
      var orphans = fees.filter(function (f) { return !used[f.key]; });
      return { pairs: pairs, orphans: orphans };
    }
    function sweep(cart) {
      if (cleaning) return Promise.resolve(cart);
      var p = pair(cart), updates = {}, adds = [], strip = [];
      p.orphans.forEach(function (f) { updates[f.key] = 0; });
      p.pairs.forEach(function (pr) {
        if (pr.ref && !pr.fee) {
          var vid = pr.main.properties['Gift wrap'] === 'Yes' && pr.main.properties['Card message'] ? G.both : (pr.main.properties['Gift wrap'] === 'Yes' ? G.wrap : G.card);
          if (vid) adds.push({ id: vid, quantity: pr.main.quantity, properties: { 'For': pr.main.product_title, '_gift_ref': pr.ref } });
          else strip.push(pr.main);
        } else if (pr.fee && pr.fee.quantity !== pr.main.quantity) { updates[pr.fee.key] = pr.main.quantity; }
      });
      if (!Object.keys(updates).length && !adds.length && !strip.length) return Promise.resolve(cart);
      cleaning = true;
      var chain = Promise.resolve();
      if (Object.keys(updates).length) chain = chain.then(function () { return req(R.cartUpdate + '.js', { updates: updates }); });
      if (adds.length) chain = chain.then(function () { return req(R.cartAdd + '.js', { items: adds }); });
      strip.forEach(function (m) { chain = chain.then(function () { return req(R.cartChange + '.js', { id: m.key, quantity: m.quantity, properties: {} }).then(function () { toast(S.giftUnavailable || ''); }); }); });
      return chain.then(function () { return req(R.cart + '.js'); }).catch(function () { return req(R.cart + '.js'); }).then(function (c) { cleaning = false; return c; }, function (err) { cleaning = false; throw err; });
    }
    function commit(cart) { state = cart; d.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, pairs: pair(cart) } })); return cart; }
    function refresh() { return enqueue(function () { return req(R.cart + '.js').then(sweep).then(commit); }); }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function addItems(items) {
      return enqueue(function () {
        return req(R.cartAdd + '.js', { items: items }).then(function () {
          // The add succeeded. A failed refresh afterwards (slow network, rate limit) must not tell the shopper
          // "could not add" — they would add it twice. Retry once, then settle for a later refresh.
          return req(R.cart + '.js').catch(function () { return wait(1200).then(function () { return req(R.cart + '.js'); }); })
            .then(sweep).then(commit)
            .catch(function () { setTimeout(refresh, 2500); return state; });
        });
      });
    }
    function flush() {
      var u = pendingUpdates; pendingUpdates = {};
      if (!Object.keys(u).length) return Promise.resolve(state);
      return enqueue(function () { return req(R.cartUpdate + '.js', { updates: u }).then(sweep).then(commit).catch(function (e) { d.dispatchEvent(new CustomEvent('cart:error', { detail: e })); return req(R.cart + '.js').then(commit).then(function () { throw e; }); }); });
    }
    function setQuantity(mainKey, qty) {
      qty = Math.max(0, parseInt(qty, 10) || 0);
      var pr = state ? pair(state).pairs.filter(function (x) { return x.main.key === mainKey; })[0] : null;
      pendingUpdates[mainKey] = qty; if (pr && pr.fee) pendingUpdates[pr.fee.key] = qty;
      clearTimeout(flushTimer); flushTimer = setTimeout(function () { flush().catch(function () {}); }, 220);
      d.dispatchEvent(new CustomEvent('cart:pending', { detail: { key: mainKey, qty: qty } }));
    }
    function settle() { clearTimeout(flushTimer); return flush().then(function () { return enqueue(function () { return state; }); }); }
    function setNote(note) { return enqueue(function () { return req(R.cartUpdate + '.js', { note: note }).then(commit); }); }
    function remove(mainKey) { return setQuantity(mainKey, 0); }
    function mainCount(cart) { return (cart ? cart.items : []).filter(function (i) { return !isFee(i); }).reduce(function (a, i) { return a + i.quantity; }, 0); }
    return { settle: settle, setNote: setNote, refresh: refresh, addItems: addItems, setQuantity: setQuantity, remove: remove, pair: pair, state: function () { return state; }, mainCount: mainCount, isFee: isFee };
  })();
  TGS.cart = TgsCart;

  /* ---------- Launch free-delivery code (announcement message with "Auto-apply discount code") ----------
     Keep the code on the bag only while it can help: below the free-delivery threshold. At or above it delivery
     is free anyway, and checkout would say "code isn't available". The shopper's own codes are never touched. */
  (function AutoCode() {
    var el = $('[data-auto-discount]'); var code = el ? (el.getAttribute('data-auto-discount') || '').trim() : '';
    var busy = false;
    function codes(cart) { return (cart.discount_codes || []).map(function (c) { return c.code; }); }
    function sync(cart) {
      if (!cart || busy) return;
      var list = codes(cart), up = function (x) { return x.toUpperCase(); }, has = list.map(up).indexOf(up(code || '#')) > -1;
      var want = !!code && cart.item_count > 0 && cart.total_price < (TGS.freeShippingThreshold || 0), next = null;
      if (want && !has) next = list.concat([code]);
      if (!want && has) next = list.filter(function (x) { return up(x) !== up(code); });
      if (!code) { var stale = list.filter(function (x) { return /^FREEDELIVERY50$/i.test(x); }); if (stale.length) next = list.filter(function (x) { return !/^FREEDELIVERY50$/i.test(x); }); }
      if (!next) return;
      busy = true;
      try { if (!want) document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
      fetch((TGS.routes && TGS.routes.cartUpdate || '/cart/update') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: next.join(',') }) })
        .catch(function () {}).then(function () { busy = false; });
    }
    on(d, 'cart:updated', function (e) { sync(e.detail.cart); });
    fetch((TGS.routes && TGS.routes.cart || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(sync).catch(function () {});
  })();

  /* ---------- CartUI: one renderer for drawer and page ---------- */
  (function CartUI() {
    var surfaces = $$('[data-cart-surface]'); if (!surfaces.length) return;
    var tpl = $('#CartLineTpl');
    function setText(root, sel, text) { var e = $(sel, root); if (e) e.textContent = text; }
    function renderLine(pr) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var m = pr.main, f = pr.fee;
      node.setAttribute('data-key', m.key); if (f) node.setAttribute('data-fee-key', f.key);
      var img = $('[data-line-image]', node);
      if (img) { if (m.image) { img.src = m.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2'); img.alt = ''; } else { img.removeAttribute('src'); } }
      var t = $('[data-line-title]', node); if (t) { t.textContent = m.product_title; t.href = m.url; }
      var u = $('[data-line-url]', node); if (u) u.href = m.url;
      var meta = []; if (m.variant_title && m.variant_title !== 'Default Title') meta.push(m.variant_title);
      if (m.properties && m.properties.Size) meta.push(m.properties.Size); if (m.properties && m.properties.For) meta.push('For ' + m.properties.For);
      setText(node, '[data-line-variant]', meta.join(' · '));
      var gift = $('[data-line-gift]', node);
      if (gift) {
        if (f || (m.properties && m.properties['Gift wrap'] === 'Yes')) {
          var kind = f ? f.variant_title : (m.properties['Gift wrap'] === 'Yes' ? S.giftWrap : S.giftCard);
          var label = kind === 'Gift Wrap + Card' ? S.giftBoth : (kind === 'Gift Wrap' ? S.giftWrap : (kind === 'Handwritten Card' ? S.giftCard : kind));
          setText(node, '[data-line-gift-title]', label + (f && f.final_line_price > 0 ? ' +' + money(f.final_line_price) : ''));
          var txt = [];
          if (m.properties['Card to']) txt.push('To ' + m.properties['Card to']);
          if (m.properties['Card message']) txt.push('"' + m.properties['Card message'] + '"');
          if (m.properties['Card from']) txt.push('From ' + m.properties['Card from']);
          if (m.properties['Hide invoice'] === 'Yes') txt.push('No invoice in parcel');
          setText(node, '[data-line-gift-text]', txt.join(' — '));
          gift.hidden = false;
        } else { gift.hidden = true; }
      }
      var q = $('[data-qty-input]', node); if (q) q.value = m.quantity;
      setText(node, '[data-line-price]', money(m.final_line_price + (f ? f.final_line_price : 0)));
      return node;
    }
    function render(cart) {
      var P = TgsCart.pair(cart), count = TgsCart.mainCount(cart);
      $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.setAttribute('data-count', count); });
      surfaces.forEach(function (root) {
        var items = $('[data-cart-items]', root), empty = $('[data-cart-empty]', root), foot = $('[data-cart-footer]', root);
        if (items) { while (items.firstChild) items.removeChild(items.firstChild); P.pairs.forEach(function (pr) { items.appendChild(renderLine(pr)); }); }
        var isEmpty = P.pairs.length === 0;
        if (empty) empty.hidden = !isEmpty; if (foot) foot.hidden = isEmpty; if (items) items.hidden = isEmpty;
        setText(root, '[data-cart-subtotal]', money(cart.total_price));
        setText(root, '[data-cart-title-count]', count ? fmt(count === 1 ? (S.itemCount && S.itemCount.one) : (S.itemCount && S.itemCount.other), { count: count }) : '');
        var disc = $('[data-cart-discount-row]', root);
        if (disc) {
          var td = cart.total_discount || 0, names = [];
          (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && names.indexOf(t) < 0) names.push(t); }); });
          (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && names.indexOf(a.title) < 0) names.push(a.title); });
          disc.hidden = td <= 0; setText(root, '[data-cart-discount]', '−' + money(td));
          setText(root, '[data-cart-discount-label]', names.length ? names.join(' + ') : (S.cartDiscount || 'Discount'));
        }
        var adv = $('[data-cart-advance]', root);
        if (adv) adv.hidden = !(TGS.advanceOver > 0 && cart.total_price > TGS.advanceOver);
        var fs = $('[data-free-shipping]', root);
        if (fs) {
          var th = TGS.freeShippingThreshold || 0, done = cart.total_price >= th, pct = th ? Math.min(100, Math.round(cart.total_price / th * 100)) : 100;
          fs.classList.toggle('fs--done', done); var fill = $('[data-fs-fill]', fs); if (fill) fill.style.setProperty('--progress', pct + '%');
          setText(fs, '[data-fs-text]', done ? (S.freeShippingUnlocked || '') : fmt(S.freeShippingRemaining || '', { amount: money(th - cart.total_price) }));
          var bar = $('[data-fs-bar]', fs); if (bar) bar.setAttribute('aria-valuenow', pct);
        }
        var wa = $('[data-cart-whatsapp]', root);
        if (wa && TGS.whatsapp) {
          var lines = P.pairs.map(function (pr) { return '• ' + pr.main.quantity + ' × ' + pr.main.product_title + (pr.main.variant_title && pr.main.variant_title !== 'Default Title' ? ' (' + pr.main.variant_title + ')' : '') + (pr.fee ? ' + gift wrap/card' : ''); });
          var msg = (S.whatsappIntro || '') + '\n' + lines.join('\n') + '\n' + 'Total: ' + money(cart.total_price);
          wa.href = 'https://wa.me/' + TGS.whatsapp + '?text=' + encodeURIComponent(msg);
        }
      });
    }
    // Stock per bag line (sections/cart-stock): Shopify's bag takes any quantity and only checkout trims it.
    var caps = {};
    function loadCaps() {
      return fetch('/?sections=cart-stock', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        var m = /<script[^>]*data-cart-stock[^>]*>([\s\S]*?)<\/script>/.exec(j['cart-stock'] || ''); caps = m ? JSON.parse(m[1]) : {};
      }).catch(function () {});
    }
    function overCap(key, q) { var c = caps[key]; if (typeof c === 'number' && q > c) { toast(c === 1 ? (S.lastOne || 'Last one in stock') : TGS.fmt(S.onlyLeft || 'Only [count] left in stock', { count: c })); return c; } return null; }
    on(d, 'cart:updated', loadCaps); loadCaps();
    surfaces.forEach(function (root) {
      on(root, 'click', function (e) {
        var btn = e.target.closest('[data-qty-minus],[data-qty-plus],[data-line-remove]'); if (!btn) return;
        e.preventDefault();
        var line = btn.closest('[data-key]'), key = line.getAttribute('data-key'), input = $('[data-qty-input]', line);
        var q = parseInt(input.value, 10) || 1;
        if (btn.hasAttribute('data-line-remove')) { line.style.opacity = '.5'; TgsCart.remove(key); return; }
        q = btn.hasAttribute('data-qty-plus') ? q + 1 : Math.max(0, q - 1);
        if (btn.hasAttribute('data-qty-plus') && overCap(key, q) !== null) return;
        input.value = q; TgsCart.setQuantity(key, q);
      });
      on(root, 'change', function (e) {
        var input = e.target.closest('[data-qty-input]'); if (!input) return;
        var line = input.closest('[data-key]'), key = line.getAttribute('data-key'), q = Math.max(0, parseInt(input.value, 10) || 0), c = overCap(key, q);
        if (c !== null) { q = c; input.value = c; }
        TgsCart.setQuantity(key, q);
      });
      var note = $('[data-cart-note]', root);
      if (note) on(note, 'change', function () { TgsCart.setNote(note.value).catch(function (e) { toast(e.message || S.cartError); }); });
    });
    on(d, 'cart:updated', function (e) { render(e.detail.cart); });
    on(d, 'cart:error', function (e) { toast((e.detail && e.detail.message) || S.cartError || 'Error'); });
    var drawer = $('[data-drawer="cart"]');
    if (drawer) on(drawer, 'drawer:open', function () { TgsCart.refresh().catch(function (e) { toast(e.message || S.cartError); }); });
    if ($('#CartPage')) TgsCart.refresh().catch(function (e) { toast(e.message || S.cartError); }); else { fetch((TGS.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { var n = TgsCart.mainCount(c); $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.setAttribute('data-count', n); }); }).catch(function () {}); }
  })();

  // Finish quantity and note writes before leaving for Shopify checkout.
  on(d, 'click', function (e) {
    var link = e.target.closest('[data-checkout]'); if (!link) return;
    e.preventDefault(); if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    var note = $('[data-cart-note]');
    TgsCart.settle().then(function () { return note ? TgsCart.setNote(note.value) : null; })
      .then(function () { window.location.assign(link.href); })
      .catch(function (err) { toast(err.message || S.cartError); })
      .then(function () { link.removeAttribute('aria-busy'); });
  });

  /* ---------- Quick add (product cards, single-variant) ---------- */
  on(d, 'click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-quick-add'), 10); if (!id) return;
    b.classList.add('is-loading'); b.disabled = true;
    TgsCart.addItems([{ id: id, quantity: 1 }]).then(function () { Drawers.show('cart'); }).catch(function (err) { toast(err.message || S.atcError); }).then(function () { b.classList.remove('is-loading'); b.disabled = false; });
  });

  /* ---------- Delivery timeline outside PDP (cart) ---------- */
  $$('[data-delivery]').forEach(function (box) {
    var r = Delivery.compute(box.hasAttribute('data-delivery-gift'));
    var o = $('[data-delivery-step="ordered"]', box), s1 = $('[data-delivery-step="dispatched"]', box), s2 = $('[data-delivery-step="delivered"]', box);
    if (o) o.textContent = S.today || 'today'; if (s1) s1.textContent = r.dispatched; if (s2) s2.textContent = r.delivered;
    var fb = $('[data-delivery-fallback]', box); if (fb) fb.hidden = true; var st = $('[data-delivery-steps]', box); if (st) st.hidden = false;
  });
})();
/* Shelf carousels: mobile scroll dots + desktop arrow paging. Progressive — the grid works without it. */
(function () {
  'use strict';
  var shelves = document.querySelectorAll('[data-shelf]');
  Array.prototype.forEach.call(shelves, function (shelf) {
    var track = shelf.querySelector('[data-shelf-track]');
    var scope = shelf.closest('.crail, .shelf, section') || shelf;
    var prev = shelf.querySelector('[data-shelf-prev]') || scope.querySelector('[data-shelf-prev]');
    var next = shelf.querySelector('[data-shelf-next]') || scope.querySelector('[data-shelf-next]');
    var dots = shelf.querySelector('[data-shelf-dots]');
    var progress = shelf.querySelector('[data-shelf-progress]');
    if (!track) return;
    var items = track.children;
    function page() { return Math.max(track.clientWidth * 0.9, 1); }
    function scrollable() { return track.scrollWidth - track.clientWidth > 4; }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (dots) dots.style.display = scrollable() ? '' : 'none';
      var at = track.scrollLeft;
      if (prev) prev.disabled = at <= 8;
      if (next) next.disabled = at >= max - 8;
      shelf.classList.toggle('can-prev', at > 8);
      shelf.classList.toggle('can-next', at < max - 8);
      if (progress && max > 0) {
        var frac = Math.min(1, track.clientWidth / track.scrollWidth);
        progress.style.width = Math.max(12, frac * 100) + '%';
        progress.style.transform = 'translateX(' + (track.scrollLeft / max) * ((1 / Math.max(frac, 0.12)) - 1) * 100 + '%)';
      }
      if (dots && dots.children.length) {
        var i = Math.round(track.scrollLeft / Math.max(items[0].getBoundingClientRect().width + 12, 1));
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === Math.min(i, dots.children.length - 1)); });
      }
    }
    if (dots) {
      var count = Math.min(items.length, 8);
      for (var i = 0; i < count; i++) { var s = document.createElement('span'); s.className = 'shelf__dot' + (i === 0 ? ' is-active' : ''); dots.appendChild(s); }
      if (!scrollable()) dots.style.display = 'none';
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
    // images and webfonts change scrollWidth after parse — re-measure once settled
    window.addEventListener('load', sync);
    setTimeout(sync, 400); setTimeout(sync, 1200);
  });
})();
